































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

export interface TableOperation {
  title: string
  icon?: string
  type?: string
  click?(data: any): void
  class?: string // class名称
  style?: any
  disable?(data: any): boolean
  show?(data: any): boolean // 是否显示
}

export interface TableHander {
  title: string
  param?: string
  type?: string
  /** 自定义单元格渲染，勿与 el-table-column 的 type（selection/index/expand）混用 */
  cellType?: string
  width?: number
  /** 设置后列宽可随表格变宽；与 width 同时存在时本列用 minWidth 拉伸 */
  minWidth?: number
  hide?: boolean // 是否隐藏字段
  overflow?: boolean // 内容过长是否隐藏 默认： true
  formatter?(cellValue: any, row: any,index: number): any //用来格式化内容 Function(row, column, cellValue, index)
  operation?: Array<TableOperation>
  click?(cellValue: any, row: any, index: number): any // 点击事件，入参：当前值，当前行，index
  fixed?:string|boolean,
  slotName?: string
  selectable?(row: any, index: number): boolean
}

@Component({
  components: {},
})
export default class Table extends Vue {
  @Prop(Number) private total!: number
  @Prop(Array) private tableHander!: TableHander
  @Prop(Array) private data!: Record<string, any>
  @Prop({ type: Boolean, default: true }) private pagination!: boolean // 是否展示分页
  @Prop({ type: Number, default: 10 }) private pageSize!: number // 分页
  @Prop(Array) private operation!: Array<TableOperation>
  @Prop({ type: Boolean, default: false }) private removePadding!: boolean // 是否去除padding


  @Emit('pageChange')
  private pageChange(index: number) {
    return index
  }
  @Emit("sizeChange")
  private handleSizeChange(index:number){
    return index
  }
  @Emit('selectChange')
  private selectChange(selection: any){
    return selection
  }

  private dialogVisible = false
  private dialogImageUrl = ''
  private videoType = ['mp4', 'avi', 'flv', 'mkv', '3gp', 'mov', 'asf', 'f4v', 'mpeg', 'mpg', 'wmv', 'rm', 'rmvb', 'ts']

  private closePreviewImage(){
    this.dialogVisible = false
  }
  // 图片预览
  private previewImage(imgUrl: string){
    this.dialogImageUrl = imgUrl
    this.dialogVisible = true
  }

  private dialogImageType(url: string) {
    if (!url) {
      return ''
    }
    console.log(url)
    const lastIndex = url.lastIndexOf('.')
    const suffix = url.substring(lastIndex + 1)
    const isVideo = this.videoType.findIndex((e) => e == suffix)
    if (isVideo >= 0) {
      return 'video'
    }
    return 'img'
  }

  private isShowOption(to: TableOperation, row: any) {
    if (to.show) {
      return to.show(row)
    } else {
      return true
    }
  }

  private isDisableOption(to: TableOperation, row?: any) {
    if (to.disable) {
      return to.disable(row)
    } else {
      return false
    }
  }

//  获取tableRef
  public getTableRef(){
    return this.$refs.baseTable
  }

}
